import React, { Component } from 'react';
import { Tabs, Tab, Button } from 'react-bootstrap/lib';
import styler from 'react-styling';
import _ from 'lodash';

import List from '../List';
import { uiStateStoreInstance } from '../../Stores/UIStateStore';


const style = styler `
  Tabs
    position: absolute
    top: 65px
    width: 100%
  AdminWrapper
    position: fixed
    z-index: 99
    width: calc(100% - 60px)
    height: 52px
    border-bottom: 1px solid #DDD
    background-color: #ECECEC
  AdminBar
    position: absolute
    top: 50%
    transform: translateY(-50%)
    &LeftSide
      left: 415px
    &RightSide
      right: 15px
  Text
    margin-right: 15px
  Radio
    margin-right: 3px
`;

class ProtectedResourcesTabs extends Component {
  state: {
    resourceType: string,
  }={
    resourceType: '',
  }

  componentWillReceiveProps(nextProps: Object) {
    if (nextProps.selectedContact[0] === null) {
      this.setState({
        resourceType: '',
      });
    }
  }

  props: {
    defaultTab: string,
    handleSelect: Function,
    languagedata: Object,
    mode: string,
    contactList: Array<any>,
    meetingRoomList: Array<any>,
    otherResourcesList: Array<any>,
    letterNew: Function,
    selectedContactEmail: string,
    selectedContact: Object,
    hasMoreContact: boolean,
    hasMoreMeetingRooms: boolean,
    hasMoreOtherResources: boolean,
    loadMore: Function,
    handleContactSingleSelection: Function,
    handleContactMultiSelection: Function,
    toggleAdminMode: Function,
    handleClassification: Function,
    handleAllSelection: Function,
  }

  _toggleResourceType = (event) => {
    const resourceType = event.target.value;
    this.setState({
      resourceType,
    });
    this.props.handleClassification(resourceType);
  }

  render() {
    const isAdmin = uiStateStoreInstance.isAdmin;
    const activeView = uiStateStoreInstance.activeView;
    const adminClass = activeView === 'contact' ? 'adminmode' : '';
    return (
      <div className={`tab-contact ${adminClass}`} style={style.Tabs}>
        { isAdmin && activeView === 'contact' ?
          <div style={style.AdminWrapper}>
            <div style={style.AdminBar.LeftSide}>
              <span style={{ marginRight: '30px' }}>{this.props.languagedata.change_all}</span>
              <input type="radio" name="classify" value="Contact" style={style.Radio} checked={this.state.resourceType === 'Contact'} onChange={this._toggleResourceType} /> <span style={style.Text}>{this.props.languagedata.people}</span>
              <input type="radio" name="classify" value="MeetingRoom" style={style.Radio} checked={this.state.resourceType === 'MeetingRoom'} onChange={this._toggleResourceType} /> <span style={style.Text}>{this.props.languagedata.meeting_room}</span>
              <input type="radio" name="classify" value="Other" style={style.Radio} checked={this.state.resourceType === 'Other'} onChange={this._toggleResourceType} /> <span style={style.Text}>{this.props.languagedata.other_resource}</span>
            </div>
            <div style={style.AdminBar.RightSide}>
              <Button
                bsStyle="link"
                onClick={() => this.props.toggleAdminMode()}
              >
                <i className="fa fa-pencil fa-lg" />
              </Button>
            </div>
          </div>
        : null }
        <Tabs activeKey={this.props.defaultTab} onSelect={this.props.handleSelect}>
          <Tab eventKey={1} title={this.props.languagedata.people}>
            <List
              type="contact"
              mode={this.props.mode}
              listItems={this.props.contactList}
              letterNew={this.props.letterNew}
              selectedContactEmail={this.props.selectedContactEmail}
              selectedContact={this.props.selectedContact}
              toggleItem={(contactEmail, type, contactId) => {
                this.props.mode === 'single' ? this.props.handleContactSingleSelection(contactEmail, type) : this.props.handleContactMultiSelection(contactEmail, type, contactId);
              }}
              loadMore={_.debounce(() => this.props.loadMore('contacts'), 1000)}
              hasMore={this.props.hasMoreContact}
              handleAllSelection={this.props.handleAllSelection}
            />
          </Tab>
          <Tab eventKey={2} title={this.props.languagedata.meeting_rooms}>
            <List
              type="meetingRoom"
              mode={this.props.mode}
              listItems={this.props.meetingRoomList}
              letterNew={this.props.letterNew}
              selectedContactEmail={this.props.selectedContactEmail}
              selectedContact={this.props.selectedContact}
              toggleItem={(contactEmail, type, contactId) => {
                this.props.mode === 'single' ? this.props.handleContactSingleSelection(contactEmail, type) : this.props.handleContactMultiSelection(contactEmail, type, contactId);
              }}
              loadMore={_.debounce(() => this.props.loadMore('meetingrooms'), 1000)}
              hasMore={this.props.hasMoreMeetingRooms}
              handleAllSelection={this.props.handleAllSelection}
            />
          </Tab>
          <Tab eventKey={3} title={this.props.languagedata.other_resources}>
            <List
              type="resource"
              mode={this.props.mode}
              listItems={this.props.otherResourcesList}
              letterNew={this.props.letterNew}
              selectedContactEmail={this.props.selectedContactEmail}
              selectedContact={this.props.selectedContact}
              toggleItem={(contactEmail, type, contactId) => {
                this.props.mode === 'single' ? this.props.handleContactSingleSelection(contactEmail, type) : this.props.handleContactMultiSelection(contactEmail, type, contactId);
              }}
              loadMore={_.debounce(() => this.props.loadMore('otherResources'), 1000)}
              hasMore={this.props.hasMoreOtherResources}
              handleAllSelection={this.props.handleAllSelection}
            />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default ProtectedResourcesTabs;



// WEBPACK FOOTER //
// ./src/js/Components/Protected/ProtectedResourcesTabs.js